export const dareLevels = [
  {
    name: 'Soft',
    sub: 'Sweet & flirty',
    desc: 'Love notes, lingering touches, and sweet dares that make you blush.',
    hue: '#F472B6',
    heat: 1,
    icon: 'soft',
  },
  {
    name: 'Steamy',
    sub: 'Teasing & playful',
    desc: 'Playful challenges that build anticipation and keep you both guessing.',
    hue: '#EC4899',
    heat: 2,
    icon: 'steamy',
  },
  {
    name: 'Wild',
    sub: 'Bold & adventurous',
    desc: 'Push your comfort zone together — things you\'ve always wanted to try.',
    hue: '#DB2777',
    heat: 3,
    icon: 'wild',
  },
  {
    name: 'Hardcore',
    sub: 'Intense & uninhibited',
    desc: 'For couples who want it all — the most daring, no-holds-barred challenges.',
    hue: '#9D174D',
    heat: 4,
    icon: 'hardcore',
  },
];
